import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const cseExpandable = {
  listRowGap: css`var(--cse-expandable-list-row-gap, ${csSpacing.spacing08})`,
  listIncrementalRowGap: css`var(--cse-expandable-list-incremental-row-gap, ${csSpacing.spacing08})`,
  togglePaddingInline: css`var(--cse-expandable-toggle-padding-x, 0)`,
}

export const style: CSSResult = css`
  ::slotted([hide]) {
    display: none;
  }

  .open ::slotted([hide]) {
    display: block;
  }

  .variant-list {
    display: flex;
    flex-direction: column;
    row-gap: ${cseExpandable.listRowGap};
  }

  .variant-list-incremental {
    display: flex;
    flex-direction: column;
    row-gap: ${cseExpandable.listIncrementalRowGap};
  }

  .variant-text .content {
    display: block;
    overflow: hidden;
    position: relative;
  }

  .variant-text .content::after {
    display: none;
    content: "";
    background: linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%);;
    width: 100%;
    height: 50%;
    position: absolute;
    bottom: 0;
  }

  .variant-text.overflows .content::after {
    display: block;
  }

  .variant-text.open .content {
    max-height: none;
  }

  .variant-text.open .content::after {
    display: none;
  }

  .toggle {
    display: block;
    cursor: pointer;
    text-align: var(--cse-expandable-toggle-align, left);
    padding-inline: ${cseExpandable.togglePaddingInline};
  }
`
